export const RICH_TEXT_EDITOR_FORMATS = [
    "header",
    "font",
    "size",
    "bold",
    "italic",
    "underline",
    "list",
    "bullet",
    "align",
    "link",
    "color",
    "background",
  ];


  // Default toolbar configuration
  export const RICH_TEXT_EDITOR_DEFAULT_MODULES = {
    toolbar: {
      container: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        [{ font: [] }],
        [{ size: [] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        [{ align: [] }],
        ["link"],
        [{ color: [] }, { background: [] }],
        ["clean"],
      ],
    },
    history: {
      delay: 1000,
      maxStack: 100,
      userOnly: true,
    },
    clipboard: {
      matchVisual: true,
    },
    keyboard: {
      bindings: {},
    },
  };